import styled from "styled-components";

export const TitleH1 = styled.h1`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const SpanDescription = styled.strong`
  font-size: 22px;
  font-weight: 300;
`;

export const SpanTitleInvoice = styled.strong`
  font-size: 26px;
  font-weight: 300;
`;

export const SpanTitleInvoiceBold = styled.strong`
  font-size: 26px;
  font-weight: 600;
`;

export const BiggerTextInvoice = styled.strong`
  font-size: 4rem;
`;

export const SpanTextInvoiceBold = styled.strong`
  font-size: 26px;
  font-weight: 600;
  padding-left: 1rem;
`;
